import React, { useState } from 'react';

export const GaleryMansionGrid = ({ images = [], id }) => {
    const [selectedImage, setSelectedImage] = useState(null);

    const closeModal = () => {
        setSelectedImage(null);
        document.getElementById(`image_modal_${id}`).close();
    };

    const handleImageClick = (img) => {
        setSelectedImage(img);
        document.getElementById(`image_modal_${id}`).showModal();
    };

    const handleClickOutside = (e) => {
        const modalBox = document.querySelector(`#image_modal_${id} .modal-box`);
        if (modalBox && !modalBox.contains(e.target)) {
            closeModal();
        }
    };

    return (
        <div>
            <div className='flex flex-wrap gap-2'>
                {images.map((img, index) => (
                <img
                    key={index}
                    src={img}
                    alt={`image-${index}`}
                    className="h-auto max-w-full rounded-lg object-cover cursor-pointer"
                    onClick={() => handleImageClick(img)}
                    loading="lazy"
                />
            ))}
            </div>
            <dialog id={`image_modal_${id}`} className="modal" onClick={handleClickOutside}>
                <div className="modal-box">
                    <button
                        className="btn btn-sm btn-circle btn-ghost absolute right-2 top-2"
                        onClick={closeModal}
                    >
                        ✕
                    </button>

                    {selectedImage && (
                        <div className="py-4">
                            <img
                                src={selectedImage}
                                alt="Zoomed"
                                className="w-full h-auto rounded-lg object-cover object-center cursor-pointer"
                            />
                        </div>
                    )}
                </div>
            </dialog>
        </div>
    );
};
